<template>
    <div class="type-div">
        <!-- <div v-if="backgroundUrl" :style="{ backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : ''}"> -->
        <!-- <div v-if="backgroundUrl" class="img-box" :style="{ backgroundImage: `url(${backgroundUrl})`}">
        </div> -->
        <img v-if="backgroundUrl" class="img-box" :src="backgroundUrl" alt=""/>
        <img v-else class="img-box" src="./default.svg" alt=""/>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import modelLabel from './modelLabel.svg';
import n from './n.svg';
import y from './y.svg';
import zPara from './zPara.svg';
import offset from './offset.svg';

const props = defineProps({
    paramsBg: {
        type: String,
        required: true
    }
})
const imageUrlList = [ 'modelLabel', 'n', 'y', 'zPara', 'offset' ];
// const backgroundUrl = ref(require('./smileLibrarySelection.svg'));
// const backgroundUrl = computed(() => imageUrlList.includes(props.paramsBg) ? require(`./${props.paramsBg}.svg`) : require('./smileLibrarySelection.svg'));

const imageFileList = {
    modelLabel,
    n,
    y,
    zPara,
    offset
};

const backgroundUrl = computed(() => {
    let url = '';

    if ( imageUrlList.includes(props.paramsBg) ) {
        url = imageFileList[props.paramsBg];
    }
    return url;
});
</script>

<style lang="scss" scoped>
.type-div{
    .img-box{
        width: 100%;
        height: 100%;
        background-size: 100% 100% !important;
        background-repeat: no-repeat;
    }
}
</style>